import React, { Fragment, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  useAddBookmarkEventMutation,
  useApplyEventsMutation,
} from "../../Store/api/DataApi";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../Store";
import {
  error,
  noPermissionAlert,
  success,
  waringMessage,
} from "../../Services/CommonService";
import { actionLogout } from "../../Store/slices/AuthSlice";

export default function ModalComponent(props) {
  const { event, eventType } = props;
  const [applyEvent] = useApplyEventsMutation();
  const [bookmarkEvent] = useAddBookmarkEventMutation();
  const { isAuth, profile } = useSelector((state: RootState) => state.auth);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onNavigate = useCallback(
    (e) => {
      e.preventDefault();
      window.$("#signup").modal("hide");
      navigate("/login");
    },
    [navigate]
  );

  const handleApplyEvent = useCallback(
    (id) => {
      if (isAuth && profile?.lgbt_status === 1) {
        applyEvent(id)
          .then((res) => {
            window.$("#signup").modal("hide");
            if (res.error) {
              error(res?.error?.data?.error);
            } else {
              success(res?.data?.message);
            }
          })
          .catch((err) => {
            error(err?.error?.data?.error);
          });
      } else if (isAuth && profile?.lgbt_status === 0) {
        window.$("#signup").modal("hide");
        noPermissionAlert();
      } else {
        window.$("#signup").modal("hide");
        waringMessage("Apply Event");
      }
    },
    [applyEvent, isAuth, profile]
  );

  const handleBookmark = useCallback(
    (id) => {
      if (isAuth && profile?.lgbt_status === 1) {
        bookmarkEvent(id)
          .then((res) => {
            //console.log(res.error.data.error);
            if (res?.error?.data?.error !== undefined) {
              error(res?.error?.data?.error);
            } else if (res.data?.error !== undefined) {
              error(res.data?.error);
              if (res.data?.error === "Invalid token!") {
                dispatch(actionLogout());
              }
            } else {
              success(res?.data?.message);
            }
          })
          .catch((err) => {
            error(err?.error?.data?.error);
          });
      } else if (isAuth && profile?.lgbt_status === 0) {
        noPermissionAlert();
      } else {
        waringMessage("Event Bookmark");
      }
    },
    [bookmarkEvent, isAuth, profile, dispatch]
  );

  return (
    <Fragment>
      <div
        className="modal fade"
        id="signup"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="myModalLabel2"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header bg-dark">
              <p className="modal-title text-white">{event?.title}</p>
              <button
                type="button"
                className="close text-white"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="tab" role="tabpanel">
                {/* <p className="signin-text">{event?.title}</p> */}
                <div className="tab-content" id="myModalLabel2">
                  <div role="tabpanel" className="tab-pane active" id="login">
                    <div className="p-40 pt-0">
                      <h6>{event?.facilitated_by}</h6>
                      <p className="pt-20">
                        <span>
                          <i className="fa fa-calendar" /> &nbsp;{" "}
                          {event?.start_date}
                        </span>
                        <br />
                        <span>
                          <i className="fa fa-clock-o" /> &nbsp;{" "}
                          {event?.start_time}
                        </span>
                        <br />
                        <span>
                          <i className="fa fa-thumb-tack" /> &nbsp;{" "}
                          {event?.location}
                        </span>
                        <br />
                        <span>
                          <i className="fa fa-user" /> &nbsp; For{" "}
                          {event?.who_can_attend}
                        </span>
                        <br />
                        <span>
                          <i className="fa fa-book" /> &nbsp; EV-{event?.id}
                        </span>
                        <br />
                        <span>
                          <i className="fa fa-ticket" /> &nbsp;{" "}
                          {event?.ticket_price}
                        </span>
                        <br />
                        <span>
                          <i className="fa fa-pencil" /> &nbsp;{" "}
                          {event?.register_defore}
                        </span>
                      </p>
                      <hr />
                      <h6>Speaker/Trainer Details</h6>
                      <div
                        className="pt-10"
                        dangerouslySetInnerHTML={{
                          __html: event?.trainer_details,
                        }}
                      ></div>
                      <hr />
                      <h6>Description</h6>
                      <p
                        className="pt-10"
                        dangerouslySetInnerHTML={{ __html: event?.summary }}
                      ></p>

                      {eventType === "upcoming" && (
                        <>
                          {isAuth ? (
                            <>
                              <a
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleApplyEvent(event?.id);
                                }}
                                className="btn btn-info"
                              >
                                Apply Event
                              </a>
                              <button
                                onClick={() => handleBookmark(event?.id)}
                                className="ml-3 btn btn-primary"
                              >
                                <span className="lnr lnr-heart" />
                              </button>
                            </>
                          ) : (
                            <a onClick={onNavigate} className="btn btn-info">
                              Register Now
                            </a>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
